import React from 'react'

const TraitColorPicker = ({ onSelect, variations, currentVariation }) => {
  if (!variations || variations.length < 1) {
    variations = [currentVariation];
  }

  return (
    <div className='product-color-picker'>
      <ul className='variantSwatch' name="variants">
        {variations.map(
          (variation, i) => {
            const selectId = `swatch-${variation.Code}`;
            const selectorImage = variation.VariantSelectorImage != null ? variation.VariantSelectorImage.Url : "";
            var isSelected = variation.Code === currentVariation.Code;

            return (
              <li className={`swatches ${isSelected ? 'selected' : ''}`} id={selectId} key={selectId}>
                <a data-code={selectId} className='variations-select' onClick={(e) => onSelect(variation.Code)}>
                  <div title={variation.Name} style={{ backgroundColor: variation.ColorSwatch }}>
                    <img src={selectorImage} className='img-responsive' />
                  </div>
                </a>
              </li>
            );
          }
        )}
      </ul>
    </div>
  );
}

export default TraitColorPicker;